




import {Component, Vue} from "vue-property-decorator"
import {vxm} from "@/store"

@Component
export default class Test extends Vue {

  onClickTest() {
    if (!window.Notification) {
      alert("このブラウザは対応していません。")
      return
    }

    Notification.requestPermission(result => {
      if (result === "denied") {
        alert("通知が許可されていません")
        return
      } else if (result === "default") {
        alert("通知可能か不明です")
        return
      }
      try {
        navigator.serviceWorker.getRegistration()
          .then(reg => {
            if (!reg) return
            reg.showNotification("Guarda il videoclip!", {
              body: "clicca qua!",
              icon: "images/she_is_fire.png",
              vibrate: [100, 50, 100],
              tag: 'sample',
              actions: [{ action: 'explore', title: 'Guarda', icon: 'images/she_is_fire.png' }],
            });
            self.addEventListener('notificationclick', function(event) {
              // event.notification.close();
              window.open("https://youtu.be/PAvHeRGZ_lA");
            }, false);
            console.log('!!!!!!!!!!!')
          })
          .catch(err => alert('Service Worker registration error: ' + err));

      } catch (err) {
        alert('Notification API error: ' + err);
      }

    })
  }
}
